/* eslint-disable no-restricted-globals */
import React from 'react';
import { useSelector } from 'react-redux';
import { User, UserProfileTab } from './types';
import './UserProfileHeader.scss';
import { Typography } from "src/latest/src/components";


type props = {
  userProfileDetails: User;
  profileTabs: UserProfileTab[];
  selectedTab: string;
};

export default function UserProfileTabs({
  userProfileDetails,
  profileTabs,
  selectedTab,
}: props) {
  const { loggedInUser } = useSelector(
    ({ authentication }: any) => authentication,
  );

  return (
    <>
      {userProfileDetails && (
        <div className="links">
          {profileTabs.map((item: UserProfileTab) => (
            <React.Fragment key={item.label}>
              {item &&
                (!item.isVisible ||
                  item.isVisible(userProfileDetails, loggedInUser)) && (
                  <a
                    href={`#${item.label.toLowerCase().replace(' ', '_')}`}
                    key={item.label}
                    className={`${
                      selectedTab === item.label.toLowerCase()
                        ? 'header-profile__active'
                        : ''
                    }`}
                  >
                    <Typography color="color-2" variant="size-14" weight="bold">
                      {item.label}
                    </Typography>
                  </a>
                )}
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  );
}
